/**
 * A component that confirms the selection for multiple answer modules.
 */
import React from "react";
import { connect } from "react-redux";

import styled from "styled-components";
import { getActiveModule, getLastMessageNumber, getMessageAnswer } from "../store";

import { deepChange, goToModule } from "../actions";
import type { GlobalState } from "../lib/types";

/**
 * ConfirmSelectionButton component.
 */
class ConfirmSelectionButton extends React.Component {
  confirmSelection = () => {
    const { messageAnswer, activeModule, dispatch } = this.props;
    const selectedAnswersNumber = messageAnswer.length;
    if (!selectedAnswersNumber) {
      return null;
    }
    let formattedAnswer = "";
    if (selectedAnswersNumber > 1) {
      const copy = [...messageAnswer];
      const lastElem = copy.splice(-1);
      formattedAnswer = copy.join(", ");
      formattedAnswer = `${formattedAnswer} and ${lastElem}`;
    } else {
      formattedAnswer = messageAnswer[0];
    }
    // dispatch(
    //   addMessage({ type: messageTypes.USER_MESSAGE, text: formattedAnswer })
    // );
    if (activeModule.key) {
      dispatch(
        deepChange({
          path: ["userData", activeModule.key],
          value: formattedAnswer,
        })
      );
    }
    dispatch(goToModule(activeModule.action));
  };

  render() {
    const { messageAnswer } = this.props;
    const selectedAnswersNumber = messageAnswer.length;
    return (
      <ConfirmButton>
        <div
          className={`${selectedAnswersNumber > 0 ? "text active" : "text"} confirmation`}
          onClick={this.confirmSelection}
        >
          Confirm selections ({selectedAnswersNumber})
        </div>
      </ConfirmButton>
    );
  }
}

const ConfirmButton = styled.div`
  margin: 16px;
  .text {
    position: relative;
    text-align: center;
    font-weight: 300;
    outline: none;
    border: 0;
    line-height: 50px;
    width: 100%;
    letter-spacing: 0.3px;
    font-size: 16px;
    border-radius: 6px;
    color: white;

    background: #ccc;
    cursor: not-allowed;

    &.active {
      cursor: pointer;
      background: ${(props) => props.theme.brandColor};
    }
  }
`;

/**
 * Map state to props.
 */
function mapStateToProps(state: GlobalState, ownProps) {
  const messageNum = getLastMessageNumber(state);
  return {
    messageAnswer: getMessageAnswer({ state, messageNum }) || [],
    activeModule: getActiveModule(state),
  };
}

export default connect(mapStateToProps)(ConfirmSelectionButton);
